import React from 'react';

import PropTypes from 'prop-types';

import theme from '@adsk/alloy-react-theme';

const ReferencePickerBlockTitle = ({ style, className, children }) => {
  return (
    <div
      data-testid="reference-picker-block-title"
      className={className}
      css={[
        {
          background: theme.colors.charcoal050,
          padding: '14px 16px',
          color: theme.colors.charcoal900,
        },
        theme.typography.bodyMedium,
        style,
      ]}
    >
      {children}
    </div>
  );
};

ReferencePickerBlockTitle.propTypes = {
  /** Styles applied to the root element */
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Title content */
  children: PropTypes.node,
};

export default ReferencePickerBlockTitle;
